import React, { useState, useEffect,useContext } from "react";
import { Grid, Card, CardContent, Typography, Box,Button,CardMedia } from "@mui/material";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import "./EmployeeView.css";
import config from "config/config";
import Context from "context/context";
import { toast } from "react-toastify";
import ReusableTable from "components/table/table";
import Tooltip from '@mui/material/Tooltip';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import selfassessment from 'assets/images/selfassesment.png'
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ToastContainer} from 'react-toastify';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab} from '@mui/material';
import { Doughnut } from "react-chartjs-2";


import {
    
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    
  } from "@mui/material";

const History = () => {
    
    const [employeeCycles, setEmployeeCycles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCycle, setSelectedCycle] = useState(null);
    const [templateData, setTemplateData] = useState([]);
    const [isTemplateLoading, setIsTemplateLoading] = useState(false);
    const [offset, setOffset] = useState(0);
    const [searchValue, setSearchValue] = useState("");
    const [formattedTemplateData, setFormattedTemplateData] = useState([]);
    const [assignedGoals, setAssignedGoals] = useState([]);
    const { state, dispatch } = useContext(Context);
  const [count, setCount] = useState(0); // Add a count for pagination
  const [appraisalCycleId, setAppraisalCycleId] = useState(null);
  const [hasInitialized, setHasInitialized] = useState(false);
  const [value, setValue] = useState("1");
  const [overAllRating, setoverAllRating] = useState("");
  const [achievements, setachievements] = useState("");
  const [areaOfImprovements, setareaOfImprovements] = useState("");
  const [yearEndCycle, setYearEndCycle] = useState(null);


  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({
    kraCategory: "",
    kpiName: "",
    selfRating: "",
    justification: "",
  });
  const [originalData, setOriginalData] = useState({
    selfRating: "",
    justification: "",
  });
  const currentYear = new Date().getFullYear().toString();

  const [selectedYear, setSelectedYear] = useState(currentYear);

  const handleYearChange = (event) => {
    console.log("Event value received:", event.target.value); // Debugging the value
    const year = event.target.value; // No conversion unless needed
    console.log("Extracted Year as String:", year);

    setSelectedYear(year);

    // Debugging - Toast to confirm
  };

  const yearOptions = Array.from({ length: parseInt(currentYear) - 2000 + 1 }, (_, index) =>
    (2000 + index).toString()
  );

  
    const defaultCycles = ["Q1", "Q2", "Q3", "Q4", "Yearly"];
  
    useEffect(() => {
      fetchAppraisalCycles();
      console.log(typeof overAllRating); // Debug the type of overAllRating
console.log(overAllRating);
    }, []);
    useEffect(() => {
        fetchAppraisalCycles();
        
      }, [selectedYear]);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

  
  
    const fetchAppraisalCycles = async () => {
      try {
        dispatch({ type: "SET_LOADING", payload: true });
        const url = `${config.host}/panel/pms/history/allAppraisalCycles?filterValue=${selectedYear}`;
        const response = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });
  
        if (!response.ok) {
          throw new Error("Error fetching appraisal cycles");
          dispatch({ type: "SET_LOADING", payload: false });
        }
  
        const responseBody = await response.text();

    // If the response body is empty, display a message
    if (!responseBody) {
        toast.error("No data found for the selected year.");
        setEmployeeCycles([]); // Clear any existing data in state
        setYearEndCycle(null);  // Clear year-end cycle data as well
        dispatch({ type: "SET_LOADING", payload: false });
        return; // Exit early since there is no data to process
      }
  
    // Parse the JSON data from the response body
    const data = JSON.parse(responseBody);
  
        if (data.status === "Ok" && Array.isArray(data.data.employeeCycles)) {
          const sortedCycles = defaultCycles
            .map((cycleName) =>
              data.data.employeeCycles.find((item) => item.cycleName === cycleName)
            )
            .filter(Boolean); 
          setEmployeeCycles(sortedCycles);
          if (Array.isArray(data.data.yearEndCycle) && data.data.yearEndCycle.length > 0) {
            setYearEndCycle(data.data.yearEndCycle[0]); // Assuming only one year-end cycle
          }
    
          dispatch({ type: "SET_LOADING", payload: false });
        } else {
            throw new Error("Unexpected data format");
      dispatch({ type: "SET_LOADING", payload: false });
        }
      } catch (error) {
        console.error("Error fetching appraisal cycles:", error);
        dispatch({ type: "SET_LOADING", payload: false });
      } finally {
        dispatch({ type: "SET_LOADING", payload: false });
      }
    };
  
    const fetchTemplateData = async (appraisalId) => {
        dispatch({ type: "SET_LOADING", payload: true });
        setIsTemplateLoading(true);
        try {
          const url = `${config.host}/panel/pms/history/CycleHistory?appraisalId=${appraisalId}`;
          const response = await fetch(url, {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          });
    
          if (!response.ok) {
            throw new Error("Error fetching template data");
            dispatch({ type: "SET_LOADING", payload: false });
          }
    
          const data = await response.json();
    
          if (data.status === "Ok" && Array.isArray(data.data)) {
            const formattedDataView = data.data.flatMap((employee, index) =>
              employee.kpiDetails.map((kpi, kpiIndex) => ({
                id: kpi.kpiKraDetailsId,
                employeeAssessmentsId: employee.employeeAssessmentsId,
                index: kpiIndex + 1, 
                kpiName: kpi.kpiName,
                weightage: kpi.weightage,
                kraCategory: kpi.kraCategory,
                templateName: employee.templateName,
                selfRating: kpi.selfRating , 
                justification: kpi.justification , 
                managerRating:kpi.managerRating,
                managerComments:kpi.managerComments,
                overAllRating:parseFloat(employee.overAllRating),
                achievements:employee.achievements,
                areaOfImprovements:employee.areaOfImprovements,
              }))
            );
            
            setAssignedGoals(formattedDataView); 
            if (data.data.length > 0) {
                const firstEmployee = data.data[0];
                setoverAllRating(parseFloat(firstEmployee.overAllRating)); // Ensure it's a number
                setachievements(firstEmployee.achievements || ""); // Handle undefined/null values
                setareaOfImprovements(firstEmployee.areaOfImprovements || ""); // Handle undefined/null values
              }
            dispatch({ type: "SET_LOADING", payload: false });
          }
        } catch (error) {
          console.error("Error fetching template data:", error);
          toast.error("Failed to fetch assigned goals");
        } finally {
            dispatch({ type: "SET_LOADING", payload: false });
        }
      };
      const fetchTemplateDataYear = async (yearEndId) => {
        dispatch({ type: "SET_LOADING", payload: true });
        setIsTemplateLoading(true);
        try {
          const url = `${config.host}/panel/pms/history/CycleHistory?yearEndId=${yearEndId}`;
          const response = await fetch(url, {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          });
    
          if (!response.ok) {
            throw new Error("Error fetching template data");
            dispatch({ type: "SET_LOADING", payload: false });
          }
    
          const data = await response.json();
    
          if (data.status === "Ok" && Array.isArray(data.data)) {
            const formattedDataView = data.data.flatMap((employee, index) =>
              employee.kpiDetails.map((kpi, kpiIndex) => ({
                id: kpi.kpiKraDetailsId,
                employeeAssessmentsId: employee.employeeAssessmentsId,
                index: kpiIndex + 1, 
                kpiName: kpi.kpiName,
                weightage: kpi.weightage,
                kraCategory: kpi.kraCategory,
                templateName: employee.templateName,
                selfRating: kpi.selfRating , 
                justification: kpi.justification , 
                managerRating:kpi.managerRating,
                managerComments:kpi.managerComments,
                overAllRating:parseFloat(employee.overAllRating),
                achievements:employee.achievements,
                areaOfImprovements:employee.areaOfImprovements,
              }))
            );
            
            setAssignedGoals(formattedDataView); 
            if (data.data.length > 0) {
                const firstEmployee = data.data[0];
                setoverAllRating(parseFloat(firstEmployee.overAllRating)); // Ensure it's a number
                setachievements(firstEmployee.achievements || ""); // Handle undefined/null values
                setareaOfImprovements(firstEmployee.areaOfImprovements || ""); // Handle undefined/null values
              }
            dispatch({ type: "SET_LOADING", payload: false });
          }
        } catch (error) {
          console.error("Error fetching template data:", error);
          toast.error("Failed to fetch assigned goals");
        } finally {
            dispatch({ type: "SET_LOADING", payload: false });
        }
      };
    

      const tableDataModal = assignedGoals.map((employee) => [
        employee.index, // S.No
        employee.kraCategory,
        employee.kpiName,
        // employee.weightage,
        employee.selfRating,
        employee.justification,
        employee.managerRating,
        employee.managerComments,
      ]);
    
     
      const handleCardClickYear = (cycle) => {
        // if (cycle.employeeStatus === "Completed") {
        //     toast.info("Self-assessment has been completed for this cycle.");
        //     return; 
        //   }
        
        if (!cycle. isPublished) {
            toast.info("Year End Appraisal process is pending");
            return; // Prevent proceeding if the self-assessment is not completed
          }
        setAppraisalCycleId(cycle.yearEndId);
      setSelectedCycle(cycle);
      fetchTemplateDataYear(cycle.yearEndId);
    };
    const handleCardClick = (cycle) => {
        // if (cycle.employeeStatus === "Completed") {
        //     toast.info("Self-assessment has been completed for this cycle.");
        //     return; 
        //   }

        if (cycle.employeeStatus !== "Completed") {
            toast.info("Self-assessment is pending for this cycle.");
            return; // Prevent proceeding if the self-assessment is not completed
          }
        
          // Check if the manager review status is "Completed"
          if (cycle.managerStatus !== "Completed") {
            toast.info("Manager review is pending for this cycle.");
            return; // Prevent proceeding if the manager review is not completed
          }
        setAppraisalCycleId(cycle.cycleId);
      setSelectedCycle(cycle);
      fetchTemplateData(cycle.cycleId);
    };
  
    const handleBack = () => {
      setSelectedCycle(null);
      setTemplateData([]);
    };
    const handleViewClick = (employee) => {
        if (!employee) {
          console.error("Invalid employee data:", employee);
          return;
        }
      
        setModalData({
          kraCategory: employee.kraCategory || "",
          kpiName: employee.kpiName || "",
          selfRating: employee.selfRating || "", 
      justification: employee.justification || "", 
          employeeAssessmentsId: employee.employeeAssessmentsId, // Add assessment ID
        kpiKraId: employee.id,
        });
        setOpenModal(true);
      };
    
      const handleModalClose = () => {
        setOpenModal(false);
       
      };

      const handleAssessmentSave = async () => {
        const missingFields = assignedGoals.some((goal) => !goal.selfRating || !goal.justification);
        
        if (missingFields) {
            toast.error("Please provide both rating and justification for all KPIs.");
            return; 
        }
        
        const employeeAssessmentsId = assignedGoals[0]?.employeeAssessmentsId; 
        if (!employeeAssessmentsId) {
            toast.error("Employee Assessment ID is missing.");
            return;
        }
    
        try {
            dispatch({ type: "SET_LOADING", payload: true });
            const response = await fetch(`${config.host}/panel/pms/employee/saveAssessments`, {
                method: "POST",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    employeeAssessmentsId: employeeAssessmentsId,
                }),
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to save assessments.");
                dispatch({ type: "SET_LOADING", payload: false });
            }
    
            const data = await response.json();
    
            if (data.status === "Ok" && data.data.updated > 0) {
                toast.success("Assessment Submited Successfully!");
                setSelectedCycle(null);
                fetchAppraisalCycles();
                dispatch({ type: "SET_LOADING", payload: false });

                
            } else {
                toast.error("No changes were made. Try again.");
                dispatch({ type: "SET_LOADING", payload: false });
            }
        } catch (error) {
            console.error("Error Submitting Assessment:", error);
            toast.error(`Error: ${error.message}`);
            dispatch({ type: "SET_LOADING", payload: false });
        }
    };
    
    
      const handleModalSave = async () => {
     
        if (!modalData.selfRating || modalData.selfRating === "Pending"|| !modalData.justification) {
            toast.error("Both rating and justification are required.");
            return;
        }
          
          dispatch({ type: "SET_LOADING", payload: true }); 
      
        try {
          const response = await fetch(`${config.host}/panel/pms/employee/assessment`, {
            method: "POST",
            credentials: "include", 
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              employeeAssessmentsId: modalData.employeeAssessmentsId,
              employeeId: modalData.employeeId,
              selfRating: modalData.selfRating,
              justification: modalData.justification,
              kpiKraId: modalData.kpiKraId,
            }),
          });
      
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to save the self-review");
          }
      
          const data = await response.json();
      
          if (data.status === "Ok") {
            toast.success("Self-review saved successfully!");
            console.log("Saved Employee Assessment ID:", modalData.employeeAssessmentsId);
      
            fetchTemplateData(appraisalCycleId); 
          } else {
            toast.error("Failed to save the self-review.");
          }
        } catch (error) {
          console.error("Error saving self-review:", error);
          toast.error(`Error: ${error.message}`);
        } finally {
          dispatch({ type: "SET_LOADING", payload: false }); 
          handleModalClose(); 
        }
      };

      const getColor = (rating) => {
        if (rating < 2) return "#FF0000"; // Red
        if (rating < 4) return "#FFA500"; // Orange
        return "#00FF00"; // Green
      };
    
      const chartData = {
        datasets: [
          {
            data: [overAllRating, 5 - overAllRating],
            backgroundColor: [getColor(overAllRating), "#E0E0E0"],
            borderWidth: 1,
          },
        ],
      };
    
      const chartOptions = {
        cutout: "70%",
        plugins: {
          tooltip: { enabled: false }, // Disable tooltip for simplicity
        },
      };
      
  
   
  
    return (
      <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
   
         
            {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '100%', overflowX: 'auto' }}> */}
        <Typography
          variant="h5"
          align="center"
          className="self-title"
          
        >
          {selectedCycle ? `Employee Self Assessment-${selectedYear} ` : "Appraisal Cycle"}
        </Typography>
  
        {selectedCycle ? (
      <>
        <Button
          variant="contained"
          onClick={handleBack}
          sx={{ marginBottom: 2 }}
        >
          Back
        </Button>

        <div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "25vh", // Full height of the viewport
    textAlign: "left", // Align text in the content to the left
  }}
>
  {/* Chart Section */}
  <div style={{ width: "200px", height: "200px", position: "relative" }}>
    <Doughnut data={chartData} options={chartOptions} />
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "20px",
        fontWeight: "bold",
      }}
    >
      {overAllRating}/5
    </div>
  </div>

  {/* Spacer for padding between chart and content */}
  <div style={{ width: "20px" }}></div>

  {/* Achievements and Areas of Improvement */}
  <div>
    <Typography className="reporttitle">Achievements</Typography>
    <Typography variant="body1" style={{ marginBottom: "10px" }}>
      {achievements || "No achievements listed."}
    </Typography>

    <Typography className="reporttitle">Areas of Improvement</Typography>
    <Typography variant="body1">
      {areaOfImprovements || "No areas of improvement listed."}
    </Typography>
  </div>
</div>

        <ReusableTable
          
          data={tableDataModal}
          count={assignedGoals.length}
          offset={offset}
          setOffset={setOffset}
          limit="25"
          setSearchValue={setSearchValue}
          heading={["S.No", "KRA", "KPI", "Self Rating","Justification","Manager Rating","Comments"]}
        />
      </>
    ) : employeeCycles.length > 0 ? (

        <div>
          {/* Dropdown positioned at the top-right */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "16px",
              marginBottom: "16px",
            }}
          >
            <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
              <InputLabel>Year</InputLabel>
              <Select
                value={selectedYear} // Controlled value
                onChange={handleYearChange} // Trigger handler
                label="Year"
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300, // Enable scrolling for dropdown
                      overflowY: "auto",
                    },
                  },
                }}
              >
                {yearOptions.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "start" }}>
  {employeeCycles.map((cycle) => (
    <Card
      className="card-style"
      key={cycle.assessmentTemplateId}
      style={{
        width: "180px",
        margin: "20px",
        padding: "20px",
        textAlign: "center",
        cursor: cycle.isActive ? "pointer" : "not-allowed",
        height: "230px",
        position: "relative",
        boxShadow: cycle.isActive
          ? "0px 4px 20px rgba(0, 0, 0, 0.1)"
          : "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        opacity: cycle.isActive ? 1 : 0.5,
      }}
      onClick={() => {
        if (cycle.isActive) {
          handleCardClick(cycle);
        }
      }}
    >
      <CardMedia
        component="img"
        height="150"
        image={selfassessment}
        alt="Saved Template"
      />
      <CardContent>
        <Typography variant="h6" className="template-name">
          {cycle.templateName}
        </Typography>
        <Typography className="template-quarter" style={{ textAlign: "center" }}>
          {(() => {
            const startDate = cycle.assessmentStartDate
              ? new Date(cycle.assessmentStartDate)
              : null;
            const endDate = cycle.assessmentEndDate
              ? new Date(cycle.assessmentEndDate)
              : null;

            if (startDate) {
              const month = startDate.getMonth();
              const quarter = `Q${Math.floor(month / 3) + 1}`;

              const formattedStartDate = startDate.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
              });
              const formattedEndDate = endDate
                ? endDate.toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                  })
                : "N/A";

              return (
                <>
                  <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                    {quarter}
                  </div>
                  <div style={{ fontSize: "0.9rem" }}>
                    {formattedStartDate} - {formattedEndDate}
                  </div>
                </>
              );
            }

            return "N/A";
          })()}
        </Typography>
      </CardContent>
      {cycle.employeeStatus === "Completed" && (
        <CheckCircleIcon
          sx={{
            position: "absolute",
            bottom: "10px",
            right: "10px",
            color: "#4caf50",
            fontSize: "30px",
          }}
        />
      )}
    </Card>
  ))}

  {yearEndCycle && (
    <Card
      className="card-style"
      key={yearEndCycle.yearEndId}
      style={{
        width: "180px",
        margin: "20px",
        padding: "20px",
        textAlign: "center",
        cursor: yearEndCycle.isActive ? "pointer" : "not-allowed",
        height: "230px",
        position: "relative",
        boxShadow: yearEndCycle.isActive
          ? "0px 4px 20px rgba(0, 0, 0, 0.1)"
          : "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        opacity: yearEndCycle.isActive ? 1 : 0.5,
      }}
      onClick={() => {
        if (yearEndCycle.isActive) {
          handleCardClickYear(yearEndCycle);
        }
      }}
    >
      <CardMedia
        component="img"
        height="150"
        image={selfassessment} // Replace with appropriate image for year-end card
        alt="Year-End Template"
      />
      <CardContent>
        
        <Typography className="template-quarter" style={{ textAlign: "center" }}>
          {(() => {
            const startDate = new Date(yearEndCycle.assessmentStartDate);
            const endDate = new Date(yearEndCycle.assessmentEndDate);

            const formattedStartDate = startDate.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            });
            const formattedEndDate = endDate.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            });

            return (
              <>
                <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                  Year-End
                </div>
                <div style={{ fontSize: "0.9rem" }}>
                  {formattedStartDate} - {formattedEndDate}
                </div>
              </>
            );
          })()}
        </Typography>
      </CardContent>
      {yearEndCycle.employeeStatus === "Completed" && (
        <CheckCircleIcon
          sx={{
            position: "absolute",
            bottom: "10px",
            right: "10px",
            color: "#4caf50",
            fontSize: "30px",
          }}
        />
      )}
    </Card>
  )}
</div>

      </div>
    ) : null}
  
   


         
     <Dialog
  open={openModal}
  onClose={handleModalClose}
  maxWidth={false}
  classes={{
    paper: "self-modal-paper",
  }}
>
  <DialogTitle className="self-modal-title">Self Review</DialogTitle>
  <Grid container spacing={2} sx={{ pl: 6, pr: 5, pb: 5, mt: 2 }}>
  {/* KRA */}
  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
    <Box className="label">KRA <span style={{ color: "red" }}>*</span></Box>
    <TextField
      sx={{ border: "1px solid #B2D4F8" }}
      id="kraCategory"
      name="kraCategory"
      placeholder="Enter KRA"
      variant="outlined"
      fullWidth
      value={modalData.kraCategory}
      InputProps={{ readOnly: true }} // Make it readonly
    />
  </Grid>

  {/* KPI */}
  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
    <Box className="label">KPI <span style={{ color: "red" }}>*</span></Box>
    <TextField
      sx={{ border: "1px solid #B2D4F8" }}
      id="kpiName"
      name="kpiName"
      placeholder="Enter KPI"
      variant="outlined"
      fullWidth
      value={modalData.kpiName}
      InputProps={{ readOnly: true }} // Make it readonly
    />
  </Grid>

  {/* Self Rating */}
  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
    <Box className="label">Self Rating <span style={{ color: "red" }}>*</span></Box>
    <FormControl fullWidth>
      <Select
        labelId="self-rating-label"
        id="selfRating"
        style={{ border: "2px solid #B2D6F8", color: "grey" }}
        value={modalData.selfRating}
        onChange={(e) => setModalData((prev) => ({ ...prev, selfRating: e.target.value }))}
        displayEmpty
      >
        <MenuItem value="" disabled>Select rating</MenuItem>
        <MenuItem value="Outstanding">Outstanding</MenuItem>
        <MenuItem value="Exceeds Expectation">Exceeds Expectation</MenuItem>
        <MenuItem value="Met Expectation">Met Expectation</MenuItem>
        <MenuItem value="Met Expectation, but needs improvement">
          Met Expectation, but needs improvement
        </MenuItem>
        <MenuItem value="Does not meet expectation">
          Does not meet expectation
        </MenuItem>
      </Select>
    </FormControl>
  </Grid>

  {/* Justification */}
  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
    <Box className="label">Justification</Box>
    <TextField
      sx={{ border: "1px solid #B2D4F8" }}
      id="justification"
      name="justification"
      placeholder="Enter Justification"
      variant="outlined"
      fullWidth
      multiline
      rows={4}
      value={modalData.justification}
      onChange={(e) => setModalData((prev) => ({ ...prev, justification: e.target.value }))}
    />
  </Grid>
</Grid>

  <DialogActions>
    <Button onClick={handleModalClose} className="self-cancelButton">
      Cancel
    </Button>
    <Button onClick={handleModalSave} className='self-saveButton'>
      Save
    </Button>
  </DialogActions>
</Dialog>


    
    </div>
  );
};

export default History;
    
